import React, { useState } from "react";
import styles from './setting.module.css'
import{Link} from 'react-router-dom';
import {BiArrowBack} from 'react-icons/bi'
const Privacyset=()=>{
    const [pageState,setPageState]=useState("block");







const borderbottom={borderBottom:"solid 2px #7124BD"}




    return(
        <div style={{width:"100%"}}>
             <div  className={styles.backbtn} >
            <Link to="/setting">
           <BiArrowBack/>
         </Link>
         <span>Privacy</span>
         </div>
           <div className={styles.privacyHeader}>
              
            <div className={styles.privacynav}>
            <ul>
                <li onClick={()=>setPageState("block")} style={pageState==="block"?borderbottom:{}}>Block Account</li>
                <li  onClick={()=>setPageState("mute")} style={pageState==="mute"?borderbottom:{}} >Mute Account</li>
                
                
            </ul>
            </div>
            </div>
        
        {pageState==="block"?        
       <div className={styles.privacymain}> 
       
       {sample.map(e=>
        <div className={styles.userListItem}>
            <img src={e.pp} alt="pp"/>
            <div>
                {e.username}
                <span>{e.name}</span>
            </div>
            <button className={styles.unblock}>Unblock</button>
            
        </div>
        )}

        </div>:""}
        {pageState==="mute"?        
        <div>
        <h5 className={styles.noac}>
            No  Mute Account
        </h5>

        </div>:""}
        



          

        </div>   
       
    )
}

export default Privacyset

const sample = [
{
    id:1,
    username:"arham_choudhary",
    pp:"https://cultivatedculture.com/wp-content/uploads/2019/12/LinkedIn-Profile-Picture-Example-Tynan-Allan.jpeg",
    name:"Arham"
},
{
    
        id:2,
        username:"tp0078",
        pp:"https://organicthemes.com/demo/profile/files/2018/05/profile-pic.jpg",
        name:"Tahir"
    
},{
    id:3,
    username:"arhamchoudhary",
    pp:"https://cultivatedculture.com/wp-content/uploads/2019/12/LinkedIn-Profile-Picture-Example-Tynan-Allan.jpeg",
    action:true,
    name:"Arham"
},
{
    
        id:4,
        username:"tp0078",
        pp:"https://organicthemes.com/demo/profile/files/2018/05/profile-pic.jpg",
       name:"Tahir"
    
}]